import { render } from "./SubNavigationBar.vue?vue&type=template&id=28537594"
import script from "./SubNavigationBar.vue?vue&type=script&lang=js"
export * from "./SubNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__